import { render } from "./Login.vue?vue&type=template&id=08b4fdc3"
import script from "./Login.vue?vue&type=script&lang=js"
export * from "./Login.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "08b4fdc3"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('08b4fdc3', script)) {
    api.reload('08b4fdc3', script)
  }
  
  module.hot.accept("./Login.vue?vue&type=template&id=08b4fdc3", () => {
    api.rerender('08b4fdc3', render)
  })

}

script.__file = "src/components/login/Login.vue"

export default script